/**
 * Дисклеймер об использовании куков
 */

class Cookie {
    constructor(el) {
        this.container = el;
        this.checkHistory();

        // localStorage.clear(); // debug для IE и мобильных устройств
    }


    checkHistory() {
        /**
         * Проверяем, нажимал ли пользователь кнопку
         */
        if (!window.localStorage.cookieAgree) {
            this.create();
        }
    }


    create() {
        /**
         * Создаём блок из темплейта
         */
        const html = $(this.container).html();
        document.getElementsByTagName('body')[0].insertAdjacentHTML('beforeend', html);

        this.bind();
    }


    bind() {
        /**
         * По клику на кнопку прячем блок
         */
        document.querySelectorAll('.js-cookie-agree').forEach(btn => {
            btn.addEventListener('click', () => this.hide());
        });
    }


    hide() {
        /**
         * Прячем блок и запоминаем это в localStorage
         */
        document.querySelectorAll('.js-cookie').forEach(el => {
            el.parentNode.removeChild(el);
        });

        window.localStorage.setItem('cookieAgree', true);
    }
}



document.querySelectorAll('.js-cookie-template').forEach(el => {
    new Cookie(el);
});



// WEBPACK FOOTER //
// ./_src/js/Cookie.js